import { createRouter, createWebHistory } from 'vue-router'
import HomeView from '../views/HomeView.vue'
import { Auth, getSubscriptionStatus } from '@/services'


const routes = [
  {
    path: '/',
    name: 'redirect-to-barbersunity',
    component: {
      beforeRouteEnter(to, from, next) {
        window.location.href = 'https://barbersunity.com'
      },
      render() {
        return null
      }
    }
  },
  {
    path: '/:lang/:partner',
    name: 'home',
    component: HomeView,
    props: true
  },
  {
    path: '/:lang/:partner/about',
    name: 'about',
    component: () => import(/* webpackChunkName: "about" */ '../views/AboutView.vue'),
    props: true
  },
  {
    path: '/:lang/:partner/calendar',
    name: 'calendar',
    component: () => import(/* webpackChunkName: "calendar" */ '../views/CalendarView.vue'),
    props: true
  },
  {
    path: '/:lang/:partner/form',
    name: 'form',
    component: () => import(/* webpackChunkName: "form" */ '../views/FormView.vue'),
    props: true
  },
  {
    path: '/admin',
    name: 'admin',
    component: () => import(/* webpackChunkName: "login" */ '../views/LoginView.vue'),
    props: true
  },
  {
    path: '/dashboard',
    name: 'dashboard',
    component: () => import(/* webpackChunkName: "dashboard" */ '../views/DashboardView.vue'),
    props: true,
    meta: { requiresSubscription: true }
  },
  {
    path: '/edit',
    name: 'edit',
    component: () => import(/* webpackChunkName: "dashboard" */ '../views/EditView.vue'),
    props: true,
    meta: { requiresSubscription: true }
  },
  {
    path: '/pricing',
    name: 'pricing',
    component: () => import('../views/PricingView.vue')
  },
    {
    path: '/:lang/register',
    name: 'register',
    component: () => import(/* webpackChunkName: "legal" */ '../views/RegisterView.vue')
  },
  {
    path: '/:lang/register-customer',
    name: 'register-customer',
    component: () => import('../views/RegisterCustomerView.vue')
  },
  {
    path: '/customer-profile',
  name: 'CustomerProfile',
  component: () => import('@/views/CustomerProfileView.vue'), // Ensure this file exists
  meta: { requiresAuth: true }
  },
  {
    path: '/privacy',
    name: 'privacy',
    component: () => import(/* webpackChunkName: "legal" */ '../views/PrivacyView.vue')
  },
  {
    path: '/terms',
    name: 'terms',
    component: () => import(/* webpackChunkName: "legal" */ '../views/TermsView.vue')
  },
  // { path: '/dashboard', name: 'dashboard', component: () => import('../views/AdminPanelView.vue') },
{
  path: '/superadmin',
  name: 'superadmin-login',
  component: () => import('../views/SuperAdminLogin.vue'),
  meta: { superadmin: true }
},
{
  path: '/superadmin/panel',
  name: 'superadmin-panel',
  component: () => import('../views/SuperAdminPanel.vue'),
  meta: { superadmin: true }
},
{
  path: '/:pathMatch(.*)*',
  name: 'NotFound',
  component: () => import('../views/NotFoundView.vue')
}
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

router.beforeEach(async (to, from, next) => {
  const privatePages = ["/dashboard", "/edit", "/pricing", "/customer-profile"];
  const adminPage = to.path.startsWith("/admin");
  const user = Auth.getUser();
  const isLoggedIn = Auth.authenticated(); // checks user && user.token, not just user object presence

  const isBusiness = user && !!user.collection;
  const isCustomer = user && !user.collection;

  if (privatePages.includes(to.path) && !isLoggedIn) {
    next("/admin");
    return;
  }

  if (isLoggedIn) {
    if (isCustomer && ["/dashboard", "/edit", "/pricing"].includes(to.path)) {
      next("/customer-profile");
      return;
    }
    if (isBusiness && to.path === "/customer-profile") {
      next("/dashboard");
      return;
    }
  }

  if (isLoggedIn && adminPage) {
    isBusiness ? next("/dashboard") : next("/customer-profile");
    return;
  }

  if (isLoggedIn && to.meta.requiresSubscription) {
    try {
      const res = await getSubscriptionStatus();
      const status = res.data?.status;
      if (status !== 'active' && status !== 'trialing') {
        next('/pricing');
        return;
      }
    } catch (e) {
      next('/pricing');
      return;
    }
  }

  next();
});



export default router
